import { handleActions } from 'redux-actions';
import orderBy from 'lodash/orderBy';
import {
  getPrevOverviewSteps,
  removeEmptyObjects,
} from '../../../shared/helpers';
import { initialState as overviewState } from '../Overview';
import { cardList } from '../ProjectView';

export const initialState = {
  projects: [],
  currentProject: null,
  isFetching: false,
  isFetchingProjects: false,
};

const authentication = handleActions(
  {
    SELECT_PROJECT: (state, action) => ({
      ...state,
      currentProject: action.payload.project_id,
      isFetching: false,
    }),

    SELECT_PROJECT_REQUEST: state => ({ ...state, isFetching: true }),

    SELECT_PROJECT_FAILURE: state => ({ ...state, isFetching: true }),

    GET_USER_PROJECTS_SUCCESS: (state, action) => {
      const projects = action.payload.data.map(selectedProject => {
        const cardDoneIndexes = [];
        getPrevOverviewSteps(selectedProject.current_overview_step).forEach(
          step =>
            cardDoneIndexes.push(
              overviewState.overviewSteps.findIndex(elem => elem.key === step),
            ),
        );
        const cardCurrentIndex = overviewState.overviewSteps.findIndex(
          elem => elem.key === selectedProject.current_overview_step,
        );

        const currentStep = selectedProject.current_overview_step;

        const overviewSteps = overviewState.overviewSteps.map((content, i) => {
          let status;
          if (cardDoneIndexes.includes(i)) {
            status = 'done';
          } else if (i === cardCurrentIndex) {
            status = 'current';
          } else {
            status = 'empty';
          }

          return { ...content, status };
        });

        return { ...selectedProject, currentStep, overviewSteps };
      });

      const mappedProjects = projects.map(project => {
        const onboardingInfo = project.project_onboarding_infos.map(info => {
          const response = info.question_response.map(value =>
            cardList.find(card => card.value === value),
          );

          return { ...info, card: removeEmptyObjects(response) };
        });
        return { ...project, project_onboarding_infos: onboardingInfo };
      });

      return {
        ...state,
        projects: orderBy(mappedProjects, ['created_at'], ['desc']),
        isFetchingProjects: false,
      };
    },

    CREATE_PROJECT_REQUEST: state => ({ ...state, isFetching: true }),

    CREATE_PROJECT_FAILURE: state => ({ ...state, isFetching: true }),

    CREATE_PROJECT_SUCCESS: (state, action) => ({
      ...state,
      projects: action.payload.data,
      isFetching: false,
    }),

    GET_USER_PROJECTS_REQUEST: state => ({
      ...state,
      isFetchingProjects: true,
    }),

    GET_USER_PROJECTS_FAILURE: state => ({
      ...state,
      isFetchingProjects: false,
    }),
    REMOVE_PROJECT: (state, action) => {
      const projects = state.projects.filter(
        project => project.id !== action.payload.id,
      );

      return { ...state, projects, isFetchingProjects: false };
    },
    REMOVE_PROJECT_REQUEST: state => ({ ...state, isFetchingProjects: true }),
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default authentication;



// WEBPACK FOOTER //
// ./src/store/reducers/Dashboard/index.js